<template>
    <div class="section wrapper" dir="rtl">
        <div class="container">
            <div class="breadcrumb mb-10 text-bold" id="biography" >{{  $t('welcome.title') }}  > {{  $t('welcome.speechPresident') }}</div>
        </div>
    </div>
    <div class="container mt-5 mb-5" dir="rtl">
        <div class="row back-gray">
            <div class="col-md-8">
                <p class="mb-4 fw-bold">
                    بسم الله الرحمان الرحيم والصلاة والسلام على أشرف المرسلين
                </p>
                <p class="mb-2">
                    السّلامُ عليكُم ورحمة الله تعالى وبركـاتُـــه.
                </p>
                <p class="mb-2">
                    إِنَّها لمُناسَبةٌ ذاتُ أهميةٍ خاصَّةٍ، وهي المَحَطَةُ الأخــــيرةُ في المسار الذي بَاشَـــرْنَاه معًا، وفـــاءً لـما تَعَــهَّـــدْنَا بــه أمـــــام الشـعـــب :
                </p>
                <p class="mb-2">
                    بدءًا بتعديل جوهري للدستور، مرورًا بالانتخابات التشريعية ثم المحلية اللتين انبثق منهما مجلس شعبي وطني جديد، ومجالس ولائية وبلدية منتخبة جديدة، بمَنطِقْ انتخابي جديد، لا غُبَارَ على نَزَاهَةِ الانتخابات، وإبعادِ المال. ووصـولاً إلى تجديد وتنصيب المؤسسات والهيئات الدستورية الأخرى (المحكمة الدستورية والمرصد الوطني للمجتمع المدني).
                </p>
                <p class="mb-2">
                    لَقَدْ تابعتُ بارتياحٍ حَمَاسَ الشباب خلال الندوات البلدية والولائية، وهو يُعَبِّرُ عن ثِقَتِـهِ في الإرادةِ التي تَحْــــدُونا جميــــعًا لتَأْسِيـــسِ رُؤْيَـــةٍ جــديــدة تَقُوم على مصداقية مُؤسَّساتِ الدولــــة، ونجاعة هيآتـِهــا الوَطنية، والتي نحرص في الجزائرِ التي نَبْنِيـهَا في هذه المرحلة معًا، أَنْ تَكُونَ بعيــدةً كُل البُعد عَنِ الشَّوَائِــب التي شَوَّهَــتْ سَيْـرَها وأَضَــرَّتْ بِمصْدَاقِيتِـهـا .. وَبَعيدَة عَن المُمَارسَاتِ التي زَرَعَتْ فِي نَفْسِ المُواطــــن التوجُّسَ والرِّيبــَــة، لـِمَا كانَ يَرْصُدُه منْ انحرافات مَسَّــــتْ بـــِـهَـــــيْــبَـــةِ المؤسسات، وزَعْزَعَـــــتْ الثقّــــةَ في الهَيْئَـــاتِ الوطنيــــة .. وأَسَــاءتْ بِشكْلٍ عَامٍ لصُـــورة الدَّولــــة، فَلَقَدْ كُنَّا منذُ أكثرَ مِن سَنَتَيْن أمَامَ واقعٍ، يُملي عليْنَا فـي أَغْلَـــبِ الأحيـــان، مراجعــةً جِذْريــــةً لأساليـــب الأداءِ، ولإحداثِ القطيعة مع الممارسات التي أَنْتَجَتْ نُفُور المواطن من كلِّ ما يَرْمُـــــزُ إلى الدَّولـــة والسلطة.
                </p>
                <p class="mb-2">
                    وإنَّنَا اليَومَ وَنَحْنُ نَتَقَدم بِعَزِيمَة وصرامة نَحْوَ بِنَاء الجزائر الجَديدَة بِكُلِّ بَنَاتِها وأَبْنَائها، لَنْ نَتَردَدَ مُطْلقًا في مُحَارَبَة تلك الذهنيات، وتحقيق تطلعات الجزائريات والجــــزائــريـــين إلى جـــزائــــر تســـود فيــها الشفـافيــة، لا مكان فيها للمال الفاسد، جزائر يَرْدَعُ فيها القانونُ كُلَّ مَنْ تُسَوِلُ لَهُ نَفْسُهُ، وَفي أَيِّ مَوقِعٍ كَانَ، مَدَّ يَدِهِ إلى المَال العَـامْ .. وتَقْطَعُ الطَّريقَ أَمَامَ نَزْعَةِ التَسَلُّطِ، بترسيخ القناعـــــة لدى الجَميـــــــع، بِأَنَّ أَفْضَلَ طَريقــــةٍ لتَجَنُّبِ الانْزِلاق نحـــو الحُكم الفَردِيُ والمُتَسَلِّطْ، هو مُمَارسَةُ المســؤوليات المُلقـــــــاةُ على عَوَاتِقِــنـــــا، بِصِدْقٍ ونزاهة، والاضطــــلاعُ بها على أَحْسَنِ وَجْهٍ.
                </p>

            </div>
            <div class="col-md-4">
                <a :href="'images/portrait.webp'" target="_blank">
                    <img :src="'images/portrait.webp'" class="img-fluid" alt="">
                </a>
            </div>
        </div>
        <div class="row back-gray">
           <p class="mb-2">
               أيتــها السيّدات .. أيــها السادة،
           </p>
            <p class="mb-4">
                إن هذه المناسبةَ، هي بمثابةِ نُقطةِ الإنطلاقِ لشبابنا، للاندماجِ في الديناميكية الجديدة التي تعرفها البلاد .. وإنَّنَا لَنَنْتَــظِـرُ مـن أعضـــاء الـمجـلــس الأعـلـى للشبــــاب من خـــلال مشاركته في تَصْمِيمِ، ومُتَابَعَةِ، وَتَقْيِيمِ المُخَطَّطِ الوَطَنِي للشَّبـَابِ، والسِّيَـــاسَـــاتِ العُمُوميَّةِ المُتَعَلِّــقَةِ به، أن يجــعـــل مــن إِنْــخِـــرَاط الشـــبــاب في الحيـــاةِ السياسيـــةِ، عَلَى رَأْس الأَوْلَوِيات في هذه المرحلة التي فَتَحنَا فيها الأَبْوَابَ وَاسِعَة أَمَامَه لِتَبُوُّءِ المَسْؤُوليَات وَالمَهَام القِيَّادِية في المُؤَسَسَات وَفي الهَيْــــئَـات المُنْتَـــخَــــبَة، ونـَعْمل فيـــها على تَوفـــــير كُلِّ الحَوَافِزِ المُشَجِعَةِ لِلشَبَابِ الطَمُوحْ، الرَاغِبِ في اقْتِحَامِ عَالَمِ الأَعْمَال والمُقَاوَلاَتِيَّة، انْطِلاَقُا من ثِقَتِنَا في القُدُرَات الهَائِلَة الكَــامِـــــنَــــةِ لَـــدَيــه، وَفي مُـــؤَهِــــــلاَتِه العِلْمِيَّةِ، وَمَا يَتَمَتَّــــــعُ بِهِ مِنْ مَكَاسِبَ ثَقَافِيَّة وَمَهَارَات، وَتَفُوّقٍ في التِكْنُولُوجِيا الحَدِيثَة بِشَتَّى مَظَاهِرِهَا .. وَكَذَلِك في مَا يتحلى بِهِ مِنْ وَعْي وَرُوح وَطَنيَّة.
            </p>
            <p class="mb-2">
                أيتها السيّدات .. أيها السادة،
            </p>
            <p class="mb-2">
                لَقَدْ انْبَثَقَ المجلسُ الأعلى للشباب في أَغْلَبِيتِهِ من نَــدَواتٍ بلديــةٍ وولائـــيَّــةٍ .. الأمرُ الــذي يَجْعـلُ أعضاءَه على دِرايَةٍ وصِلَــةٍ بِمَشَاكِلِ وتَطَلُّعَاتِ الشبـاب في الولايـات .. خصوصًـا في المَنـاطِــقِ المَعْـزُولةِ والنَّـائِيَّةِ، ومن بَابِ الحِرْصِ على دَعْـمِ هذه الهيئة، لتنطلقَ في أَدَاءِ دَورِهَا بِنَفَسٍ جَديدٍ، فإن تشكيلة أعضاء المجلس الأعلى للشباب، تَضُمُّ أَعْضَاءً مُعَيَّنِـين من القطـاعات الوزاريـــة، ومِنْ ذوي الكَفَاءَاتِ والخِبرَاتِ، التِّي تمرَّسَتْ في نشاطات المجتمع المدني والحركة الجمعويـــــة، لأن المُزَاوَجَــــــةِ بَيْنَ المُنْتَخَبِـــــينَ المُمَثِّلِينَ للشَبَــــــاب في البَلديات، والمُعَيَّنِينَ بِـــــهيئَتِكُمْ لتمثيلِ القِطَاعَاتِ الوزارية والمُنظمات والجمعيات الشبّانية، بالاضافة إلى مَبْدَإِ المُناصَفَةِ، سيجعلان من هذه الهيئة فَضَاءً وَاسِعًــا لِلْحِوارِ والتَّــدَاوُلِ لِتَقْدِيــمِ الأفْكَارِ والاقتراحاتِ التي تُتِيحُ للشَّبـَابِ تقلد المناصب وتــــولـــي المسؤوليـــــــات في حُقُـول النَّشَـاطِ السِّيَــــاســـِي والاقْتِصَــــادي والاجتـمــاعــي، إيمـــــانًا مــــنَّا بأنَّ كل القضايا المتعلقة بالشباب، لا بُدَّ أن تَمُرَّ عَبْرَ هذه الهيئة، وأن يكونَ لكُم رأيٌّ فيها، وفي اتِّخاذِ القرارات بشأنها.
            </p>
            <p class="mb-2">
                وعلى هذا الأساس، فإنَّ النِظَامَ الدَاخلي الذي سَتَعْكِفُونَ على إعْدَادِهِ، سيكونُ فرصةً لكم لتعميقِ النِّقَاش حول أنجع الآليات لأداء مهامكم والاستجابة لحاجات الشباب ومتطلبات ازدهاره من خلال المشاركة في النشاط الاقتصادي والاجتماعي والثقافي والرياضي .. والمُسَاهَمَة في ترقية القِيَمِ الوطنية، والضمير الوطني والحس الـمدني، والتضامن الاجتماعي، وتشجيع رُوح المواطنة.
            </p>
            <p class="mb-2">
                السيد مصطفى حيداوي، رئيس المجلس الأعلى للشباب،
            </p>
            <p class="mb-2">
                السيدات والسـادة الأعضاء،
            </p>
            <p class="mb-2">
                إنَّكم تُدركون - أيضا - مُسَاهَمَتكُمْ في تمجيد تاريخنا الوطني، لأنكم من سلالة الشهداء والمجاهدين، تَسِيرُونَ على نَهْجِهِمْ، وتَسْتَحْضِرُونَ المَبَادِئَ والقيَمَ، التي وَرِثَهَا الشَّعُب الجزائري عَنْهُمْ، وحَمَى بِها وِحْدَتَهُ وَتَمَاسُكَهُ، أَمَامَ المَكَائِدِ والمُنَاورَات، التي اسْتَهْدَفَتْ وَمَازَالَتْ تَسْتَهْدِفُ الأمة، وإنَّنا في هذا الظرف الذي يستدعي تَظَافُرَ جُهُودِ كُلِّ الأطْيَاف والمَشَارِبِ لتعزيزِ اللُّحْمَةِ الوطنية، وتَقْويَةِ الجَبْهةِ الدَاخليةِ، أَمَامَ مَا يُوَاجِهُنَا من تَحَدِيَاتٍ إقليميةٍ صَعْبَة .. وَرِهَانَاتٍ دوليةٍ مُعَقَدة، نُرَاهِنُ بِكُلِ ثِقَةٍ على شَبَابِنَا، الذي تَشُقُ بِه الجزائرُ طَريقَهَا إلى الرِّفْعَةِ والسُّؤْدُدِ، وهي تَسْتَعِّدُ للاحْتِفَاءِ بالذكرى الستين لاسْتِعَادة السيَّادة الوطنية، مُعْتَزَّةً بشَبَابِهَا الطَمُوحْ ..فَأنتُمْ سَواعِدُ البِنَاءْ والنَّمَاءْ والوَفَاءْ.
            </p>
            <p class="mb-2">
                وختامًا .. أُعْلِنُ رَسْميًا عن تَنْصِيب المجْلَس الأَعْلَى للشَبَـــاب.
            </p>
            <p class="mb-2">
                الـمجد والخلود لشهدائنا الأبرار
            </p>
            <p class="mb-2">
                تحيــا الجزائــر
            </p>
            <p class="mb-5">
                والسلام عليكم ورحمة الله وبركاته.
            </p>
        </div>

    </div>

</template>

<script>
    export default {
        name: "presidentState"
    }
</script>

<style scoped>
    .back-gray{
        background-color: #E7E9EB;
        padding: 15px 15px;
        text-align: justify;
        text-justify: inter-word;
    }
    .back-gray p{
        line-height: 200%;
    }
    @media (max-width: 900px) {
        .view_mobile{
            display: block!important;
        }
        .embed_pdf{
            display: none;
        }
    }
    @media (min-width: 900px) {
        .view_mobile{
            display: none!important;
        }
        .embed_pdf{
            display: block!important;
        }
    }
</style>